import Url from 'url';

export default function () {

	setTimeout(() => {
		const url = Url.parse(window.location.href, true);
		const id = url.query.id;
		const downloadPageUrls = new Map();

		fetch(`/api/storefront/order/${id}`, {credentials: 'include'}) 
		.then(response => response.json()) 
		.then(function(order) {
			if (order && order.status == "COMPLETED") {
				if (order.lineItems.digitalItems.length > 0) {
					for (let product of order.lineItems.digitalItems) {
						downloadPageUrls.set(product.productId, product.downloadPageUrl);
					}
				}

				$('.order-list-container .account-listItem').each((index, item) => {
					const $input = $(item).find('.account-product-checkItem [id^="account-product-"]');
					if ($input) {
						const productId = $input.data('product-id');
						if (downloadPageUrls.has(productId)) {
							let button = $('<div>', {"class": "goto-download-button"})
							let link = $('<a href=' + downloadPageUrls.get(productId) + '></a>');
							let span = $('<span>', {"class": "button btn_green"}).html('Go to Downloads<span class="icon icon-right"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-down"></use></svg></span>');
							link.append(span);
							button.append(link);
							$(item).addClass('download-item').append(button);
						}
					}
				})
			}
		});

	}, 1500)
}
